// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.constant-detail {\n  height: calc(100vh - 100px);\n  margin: -15px;\n  overflow: auto;\n  padding: 20px;\n}\n.el-drawer .el-drawer__header {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
